import type { ServiceCode } from '@common/enums/serviceCode';
import type { PatientInsuranceHistory } from '@common/interfaces/api/patientsApi';
import { fetchJson } from '@frontend/store/fetch';
import { findByCode } from './servicesApiService';

export async function getPatientHasContractedCare(code: ServiceCode, patientId: string, signal: AbortSignal) {
    const service = await findByCode(code, signal);
    const url = `/api/patients/${patientId}/hasContractedCare/${service.id}`;
    const result = await fetchJson({ method: 'GET', signal, url });

    if (!result.json) {
        return;
    }

    return result.json;
}

export async function getActiveInsuranceFromInsuranceHistory(
    patientId: string,
    signal: AbortSignal
): Promise<PatientInsuranceHistory | null> {
    const url = `/api/patients/${patientId}/insuranceHistory?isActive=true`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json.items.length > 0 ? result.json.items[0] : null;
}
